// extracted by mini-css-extract-plugin
export default {"root":"ActiveCallLabel_root__brDQX"};